import PropTypes from 'prop-types';

import { EmptySet } from 'basic-components/icons';

import { Else, If, Then } from 'react-if';

const EMPTY_OBJ = {};

const ProviderIcon = ({ activeProvider = EMPTY_OBJ }) => (
  <div className="provider-selector__icon">
    <If condition={activeProvider?.iconUrl}>
      <Then>
        {() => (
          <img
              alt={`${activeProvider?.readableName} Source`}
              src={activeProvider.iconUrl}
              width="24px"
          />
        )}
      </Then>
      <Else>
        {() => (
          <EmptySet
              color="grey-dark"
              height={16}
              width={16}
          />
        )}
      </Else>
    </If>
  </div>
)

  ProviderIcon.propTypes = {
    activeProvider: PropTypes.object
  }

export default ProviderIcon;